import { InitiativeSonarObject } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetInitiativeSonarObjectsRequest = KeyPaginationQueryParams & {
	initiativeId: number;
	objectNameSearchText?: string;
	objectTypes?: Array<string>;
	ordering?: string;
};

export type GetInitiativeSonarObjectsResponse = PaginatedResource<InitiativeSonarObject>;

export const getInitiativeSonarObjects = createGetEndpoint<
	GetInitiativeSonarObjectsRequest,
	GetInitiativeSonarObjectsResponse
>(({ initiativeId, ...rest }) => `/api/v3/initiatives/${initiativeId}/sonarobjects?${getQueryString(rest)}`);
